"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.controlBorderStyle = exports.focusStyle = void 0;

var _styledComponents = require("styled-components");
/* eslint-disable import/prefer-default-export */
// focus also supports clickable elements inside svg


var focusStyle = (0, _styledComponents.css)(["> circle,> ellipse,> line,> path,> polygon,> polyline,> rect{outline:", " solid 2px;}border-color:", ";box-shadow:0 0 1px 1px ", ";::-moz-focus-inner{border:0;}"], function (props) {
  return props.theme.global.focus.border.color;
}, function (props) {
  return props.theme.global.focus.border.color;
}, function (props) {
  return props.theme.global.focus.border.color;
});
exports.focusStyle = focusStyle;
var controlBorderStyle = (0, _styledComponents.css)(["border:", " solid ", ";border-radius:", ";"], function (props) {
  return props.theme.global.control.border.width;
}, function (props) {
  return props.theme.global.control.border.color;
}, function (props) {
  return props.theme.global.control.border.radius;
});
exports.controlBorderStyle = controlBorderStyle;